import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { globalConfigUrl } from 'Configuration/config';
import { msalConfig } from 'authConfig';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { AccountInfo, EventMessage, EventType } from '@azure/msal-browser';
import { setCurrentEmployee, setCurrentUser } from 'features/Auth-Slice';
import { setServiceMessages } from 'features/ServiceMessage-Slice';
import { useDispatch } from "react-redux";
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { appInsights } from 'appInsightsAuth';
import { toastConfig } from 'Components/Constants';
import { toast } from 'react-toastify';
import { SusiUserType } from 'Components/Types';
import { EmployeeAPI } from 'API/EmployeeAPI';
import { ServiceMessagesAPI } from 'API/GeneralAPI';

const user:any = {};
export const ConfigContext = React.createContext(user);

type ConfigContextProviderProps = {
    children: React.ReactNode;
}

const ConfigContextProvider = ({ children }: ConfigContextProviderProps) => {
    const [clientId, setClientId] = useState<string>("");
    const [apiUrl, setApiUrl] = useState<string>("");
    const [logoImage, setLogoImage] = useState<string>("");

    const dispatch = useDispatch();

    var userAccount:AccountInfo = {} as AccountInfo;
    const { instance } = useMsal();

    if (useIsAuthenticated()) {
        userAccount = instance.getAllAccounts()[0];
    }

    useEffect(() => {
        const getContext = async () => {
            try {
                const response = await axios.get(globalConfigUrl);
                setClientId(response.data.b2cClientId);
                const apiUrl = response.data.apiUrl;
                setApiUrl(apiUrl);
                setLogoImage(response.data.logoImage);
                msalConfig.auth.clientId = response.data.b2cClientId;

                instance.addEventCallback(async (message: EventMessage) => {
                    const payload = message.payload as any;
                    if (message.eventType === EventType.LOGIN_SUCCESS && instance.getAllAccounts() != null) {
                        var susiUser: SusiUserType = {
                            aspnetuser_id: payload.account.localAccountId,
                            firstname: payload.account.idTokenClaims?.given_name as string,
                            lastname: payload.account.idTokenClaims?.family_name as string,
                            employer_id: payload.account.idTokenClaims?.extension_employer_id as number,
                            email: payload.account.idTokenClaims?.emails?.[0] as string,
                            gdpr_receive_email: payload.account.idTokenClaims?.extension_gdpr_receive_email as boolean,
                            newUser: false
                        };
                        const response = await EmployeeAPI.login(instance, susiUser);
                        const user = {...instance.getAllAccounts()[0]};
                        dispatch(setCurrentUser(user));
                        dispatch(setCurrentEmployee(response));
                    }

                    if (message.eventType === EventType.LOGIN_FAILURE || message.eventType === EventType.SSO_SILENT_FAILURE || message.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
                        dispatch(setCurrentUser(null));
                    }
                });
            }
            catch(error:any) {
                appInsights.trackException({ error, severityLevel: SeverityLevel.Error });
                const message = "Error while fetching global config";
                toast.error(message, { ...toastConfig, toastId: message + "-toast" });
            }
        }

        getContext();

    }, []);

    return <ConfigContext.Provider value={[clientId, apiUrl, logoImage]}> {children} </ConfigContext.Provider>;
}
export default ConfigContextProvider;